// Hideo - state of the Saved videos page (src/pages/SavedPage.vue) that outlives the page: the open tile (a tag), the
// search text, the platform filter ('' = all, otherwise a platform key) and the category filter ('' = all, KIND_NONE =
// without one, otherwise a category id: src/features/categories.ts), all kept while moving between pages. The open tag is
// mirrored in useTagStore().state.saved.filter (src/stores/tags.ts), so a new video starts with it and a rename keeps it.
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { KIND_NONE } from '../features/categories'
import { useTagStore } from './tags'

export const useSavedStore = defineStore('saved', () => {
  /** '' = closed, SAVED_ALL, TAG_NONE or a tag (src/features/savedVideos.ts) */
  const tab = ref('')
  const query = ref('')
  const platform = ref('')
  const kind = ref('')
  /** What a new saved video starts with (dialog props): the open tag and the category filter. Used by the page's
   *  button, the create button and a link dropped on the page. */
  const newArgs = () => ({ id: null, tag: useTagStore().state.saved.filter, kind: kind.value === KIND_NONE ? '' : kind.value })
  return { tab, query, platform, kind, newArgs }
})
